import { T } from "../../vue-tippy.esm-browser-BFHHjfeY.mjs";
import { defineComponent as D, ref as v, computed as E, resolveComponent as p, createElementBlock as r, openBlock as i, Fragment as h, renderSlot as $, createBlock as V, createCommentVNode as j, withDirectives as z, createVNode as d, withCtx as n, createElementVNode as a, vShow as B, Transition as N, normalizeClass as m, normalizeStyle as M, renderList as O, toDisplayString as g, createSlots as P } from "vue";
import { u as F, a as I } from "../../index-BTmZbsz8.mjs";
import { v as L } from "../../vsCard-CgHEnE92.mjs";
import { v as W } from "../../vsIcon-Cyr63bPF.mjs";
import { v as q } from "../../vsButton-BlFL21k0.mjs";
import { v as A } from "../../vsDisclosure-egvl1r1U.mjs";
import { v as G } from "../../vsToolbar-LuT78C6Q.mjs";
import { _ as H } from "../../_plugin-vue_export-helper-CHgC5LLL.mjs";
const J = D({
  name: "vs-sidebar",
  components: {
    vsCard: L,
    vsButton: q,
    vsIcon: W,
    vsDisclosure: A,
    vsToolbar: G,
    TippySingleton: T
  },
  props: {
    invisibleOnSmall: {
      type: Boolean,
      default: !1
    },
    defaultOpen: {
      type: Boolean,
      default: !1
    },
    pages: {
      type: Object,
      default: () => []
    },
    activePage: { type: String, default: "" }
  },
  emits: ["page:select", "sidebar:collapsed", "sidebar:add"],
  setup(e, { emit: l }) {
    const y = v(null), { width: S, height: w } = F(y), k = v(!0), t = window.innerWidth <= 677, u = v(!t), c = v(null);
    I(c, (f) => {
      t && (u.value = !1);
    });
    const b = E(() => e.pages.filter((f) => f.pinned));
    return { emit: l, header: y, width: S, height: w, isCollapsed: k, isVisible: u, isSmall: t, sidebar: c, pinnedPages: b };
  }
}), K = { class: "sm:hidden absolute inset-0 bg-shadow/50 backdrop-blur-sm w-full h-screen z-[99]" }, Q = {
  key: 1,
  class: "z-10 w-[88px] h-0"
}, R = {
  ref: "header",
  class: "items-center border-b border-primary-200"
}, U = { key: 0 }, X = { class: "flex items-center" }, Y = { class: "transition-all bg-primary-800 rounded-xl mt-1" }, Z = { class: "text-left" }, _ = { class: "flex" };
function x(e, l, y, S, w, k) {
  const t = p("vs-button"), u = p("vs-toolbar"), c = p("vs-icon"), b = p("vs-disclosure"), f = p("vs-card");
  return i(), r(h, null, [
    $(e.$slots, "default", { isCollapsed: e.isCollapsed }),
    !e.invisibleOnSmall && !e.isVisible ? (i(), V(u, {
      key: 0,
      class: "sm:hidden order-last",
      pages: e.pinnedPages,
      "onPage:select": l[1] || (l[1] = (s) => e.$emit("page:select", s)),
      compact: ""
    }, {
      default: n(() => [
        d(t, {
          kind: "flat",
          "icon-name": "bytesize:menu",
          class: "justify-center h-10 w-full text-on-primary rounded-full outline-secondary hover:bg-opacity-40 hover:bg-on-primary",
          onClick: l[0] || (l[0] = (s) => e.isVisible = !0)
        })
      ]),
      _: 1
    }, 8, ["pages"])) : j("", !0),
    z(a("div", K, null, 512), [
      [B, e.isVisible]
    ]),
    e.isCollapsed ? j("", !0) : (i(), r("div", Q)),
    d(N, {
      "enter-active-class": "transition duration-200 ease-out",
      "enter-from-class": "-translate-x-full opacity-0",
      "enter-to-class": "translate-x-0 opacity-100",
      "leave-active-class": "transition duration-200 ease-in",
      "leave-from-class": "translate-x-0 opacity-100",
      "leave-to-class": "-translate-x-full opacity-0"
    }, {
      default: n(() => [
        z(a("div", {
          class: m([e.isCollapsed ? "sm:!relative" : "sm:!absolute", "absolute w-5/6 sm:w-auto h-screen left-0 top-0 z-[100] transition-width duration-300"]),
          ref: "sidebar"
        }, [
          d(f, {
            class: "transition h-full left-0 top-0 border-0 overflow-y-hidden h-z-1 py-0 !px-0 z-10 bg-gradient-to-tr from-primary-500 to-primary p-safe",
            "padding-value": 2,
            "rounded-t-l": !1,
            "rounded-b-l": !1,
            "rounded-t-r": !1,
            "rounded-b-r": !1,
            onMouseenter: l[2] || (l[2] = (s) => e.isCollapsed = !1),
            onMouseleave: l[3] || (l[3] = (s) => e.isCollapsed = !0)
          }, {
            default: n(() => [
              a("div", R, [
                $(e.$slots, "header", {
                  isCollapsed: e.isCollapsed,
                  isSmall: e.isSmall
                })
              ], 512),
              a("div", {
                class: "overflow-y-scroll pl-2 pr-1 py-2",
                style: M(`height: calc(100% - ${e.height}px)`)
              }, [
                (i(!0), r(h, null, O(e.pages, (s) => (i(), r("div", {
                  key: s.id,
                  class: "space-y-1"
                }, [
                  s.group ? (i(), r("div", U, [
                    d(b, null, {
                      button: n(({ open: o }) => [
                        d(t, {
                          kind: "flat",
                          "icon-name": s.icon,
                          justify: !e.isCollapsed || e.isSmall,
                          class: m(`w-full text-white outline-secondary hover:bg-opacity-40 hover:bg-on-primary ${o ? "!bg-gradient-to-bl from-primary-500 to-secondary !text-on-secondary bg-opacity-50" : ""} ${e.isCollapsed, ""}`)
                        }, {
                          after: n(() => [
                            a("div", X, [
                              a("span", {
                                class: m(`${e.isCollapsed && !e.isSmall ? "" : "mx-2"}`)
                              }, g(!e.isCollapsed || e.isSmall ? s.name : ""), 3),
                              d(c, {
                                class: m(["text-white transform-all -rotate-90", o ? "" : "-rotate-0"]),
                                name: "akar-icons:chevron-down",
                                color: "on-" + o ? "muted" : "flat",
                                size: 12
                              }, null, 8, ["class", "color"])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["icon-name", "justify", "class"])
                      ]),
                      content: n(() => [
                        a("div", Y, [
                          (i(!0), r(h, null, O(s.pages, (o) => (i(), r("div", {
                            key: o.id
                          }, [
                            d(t, {
                              kind: "flat",
                              "icon-name": o.icon,
                              justify: !e.isCollapsed || e.isSmall,
                              class: m(`w-full text-white outline-secondary hover:bg-opacity-40 hover:bg-on-primary ${e.activePage === o.path ? "!bg-gradient-to-bl from-primary-500 to-secondary !text-on-secondary shadow-lg shadow-secondary/50" : ""} ${e.isCollapsed ? "justify-center" : ""}`),
                              onClick: (ee) => {
                                e.emit("page:select", o), e.isSmall && (e.isVisible = !1), e.isSmall && (e.isVisible = !1);
                              }
                            }, {
                              default: n(() => [
                                a("div", Z, g(!e.isCollapsed || e.isSmall ? o.name : ""), 1)
                              ]),
                              _: 2
                            }, 1032, ["icon-name", "justify", "class", "onClick"])
                          ]))), 128))
                        ])
                      ]),
                      _: 2
                    }, 1024)
                  ])) : (i(), V(t, {
                    key: 1,
                    kind: "flat",
                    "icon-name": s.icon,
                    justify: !e.isCollapsed || e.isSmall,
                    class: m(`w-full text-white outline-secondary hover:bg-opacity-40 hover:bg-on-primary ${e.activePage === s.path ? "!bg-gradient-to-bl from-primary-500 to-secondary !text-on-secondary bg-opacity-50" : ""} ${e.isCollapsed && !e.isSmall ? "justify-center" : ""}`),
                    onClick: (o) => {
                      e.emit("page:select", s), e.isSmall && (e.isVisible = !1);
                    }
                  }, P({ _: 2 }, [
                    !e.isCollapsed || e.isSmall ? {
                      name: "after",
                      fn: n(() => [
                        a("div", _, [
                          a("span", {
                            class: m(`${e.isCollapsed && !e.isSmall ? "" : "ml-2"}`)
                          }, g(!e.isCollapsed || e.isSmall ? s.name : ""), 3)
                        ])
                      ]),
                      key: "0"
                    } : void 0
                  ]), 1032, ["icon-name", "justify", "class", "onClick"]))
                ]))), 128))
              ], 4)
            ]),
            _: 3
          })
        ], 2), [
          [B, e.isVisible]
        ])
      ]),
      _: 3
    })
  ], 64);
}
const C = /* @__PURE__ */ H(J, [["render", x]]);
C.install = (e) => {
  e.component(C.name, C);
};
export {
  C as default
};
//# sourceMappingURL=index.mjs.map
